import {
    createJustText,
    IJustTextProperties,
    JustText,
} from '@vfde-brix/just-text';
import { IPatternBusinessLogic } from '@vfde-brix/core';

/**
 * Mount JustText component
 * @param container
 * @param properties
 */
const mountJustText = (container: HTMLElement, properties: IPatternBusinessLogic | IJustTextProperties = {}): JustText => {
    return createJustText(container, properties);
};

export default mountJustText;
